// extracted by mini-css-extract-plugin
export default {"bmi":"styles_bmi__338j9","normal":"styles_normal__Fi4Ey","obese":"styles_obese__OQ20S","underweight":"styles_underweight__AeBMD","overweight":"styles_overweight__Y1gnp"};